import { Component, Input } from '@angular/core';
import { StatusLoteMap } from '../../../../pages/gestao-cartoes/ativacao-lote/enums/EStatusLoteEnum';


@Component({
  selector: 'ngx-info-lote-ativacao-importacao',
  templateUrl: './info-lote-ativacao.component.html',
  styleUrls: ['./info-lote-ativacao.component.scss'],
})
export class InfoLoteAtivacaoImportacaoComponent {
  @Input() data;

  getColor() {
    if (this.data && this.data.status) {
      return StatusLoteMap[this.data.status].color;
    }
  }
}
